var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeekIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20933"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 11.718C1 7.46329 1 5.33594 2.32177 4.01415C3.64355 2.69238 5.77091 2.69238 10.0256 2.69238H14.5385C18.7931 2.69238 20.9206 2.69238 22.2423 4.01415C23.5641 5.33594 23.5641 7.46329 23.5641 11.718V13.9744C23.5641 18.2291 23.5641 20.3566 22.2423 21.6783C20.9206 23.0001 18.7931 23.0001 14.5385 23.0001H10.0256C5.77091 23.0001 3.64355 23.0001 2.32177 21.6783C1 20.3566 1 18.2291 1 13.9744V11.718Z",
    stroke: "#0078E6",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.5,
    d: "M6.64111 2.69231V1",
    stroke: "#0078E6",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.5,
    d: "M17.9229 2.69231V1",
    stroke: "#0078E6",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.5,
    d: "M1 8.3335H23.5641",
    stroke: "#0078E6",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.89746 14.5385L10.5898 12.8462V17.359",
    stroke: "#0078E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.4102 16.2308V13.9744C13.4102 13.3513 13.9153 12.8462 14.5384 12.8462C15.1615 12.8462 15.6666 13.3513 15.6666 13.9744V16.2308C15.6666 16.8539 15.1615 17.359 14.5384 17.359C13.9153 17.359 13.4102 16.8539 13.4102 16.2308Z",
    stroke: "#0078E6",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeekIcon);
export default __webpack_public_path__ + "static/media/weekIcon.f0e4bf63df4f1ba97aad23ae5f870ed8.svg";
export { ForwardRef as ReactComponent };